import Head from "components/Head";
import Banner from "./Banner";
import ProprietyDetails from "./ProprietyDetails";
import ProprietyDescription from "./ProprietyDescription";
import ProprietyLocation from "./ProprietyLocation";
import ProprietyGalery from "./ProprietyGalery";
import ReceiveNews from "components/ReceiveNews";
import ProprietyOthers from "./ProprietyOthers";
import AndamentoObras from './AndamentoObras'

export default function Detalhes({ data }) {
  return (
    <>
      <div className="container-full">
        <div className="container-geral align-items-center flex-column">
          <Head data={data.seo} />
          <Banner data={data.banner} />
          <ProprietyDetails data={data.detalhes} />
          <ProprietyDescription data={data.descricaoImovel} />
        </div>
      </div>

      <ProprietyGalery data={data.galeria} />

       <div className="container-full">
        <div className="container-geral flex-column">
          <ProprietyLocation data={data.localizacao} />
          {
            data.andamento_obras &&
              <AndamentoObras data={data.andamento_obras}/>
          }
        </div>
      </div>
      

      <div className="container-full">
        <div className="container-geral flex-column">
          <ProprietyOthers
            data={data.outros}
            cidade={data.banner.cidade.cidade}
          />
          <ReceiveNews data={data.secaoRecebaNovidades} />
        </div>
      </div>
    </>
  );
}
